module.exports = __webpack_public_path__ + "static/media/Hunter.d5f27ad8.svg";